/**
 * @param {number} total
 * @param {number} page
 * @param {number} rowsPerPage
 * @returns {{ totalPages: number, start: number, end: number }}
 */
export const getPaginationInfo = (total, page, rowsPerPage) => {
  const totalPages = Math.max(1, Math.ceil(total / rowsPerPage));
  const start = total > 0 ? (page - 1) * rowsPerPage + 1 : 0;
  const end = Math.min(page * rowsPerPage, total);
  return { totalPages, start, end };
};
